// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const FormContainer = styled.div`
    max-width: 500px;
`;